import { render, staticRenderFns } from "./loadingAnimationStartUp.vue?vue&type=template&id=adfee43e&"
import script from "./loadingAnimationStartUp.vue?vue&type=script&lang=ts&"
export * from "./loadingAnimationStartUp.vue?vue&type=script&lang=ts&"
import style0 from "./loadingAnimationStartUp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports